import { queryKeys } from '@query/keys'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useAccountReadContext } from '@context/AccountContextContext'

import { DateShortcutOption } from '@ui/v2/TableFilter/Chips/FilterChipModalDateRange'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { FilterOptionsDto } from '@model/FilterOptionsDto'

import { currentYear, lastMonth, thisMonth } from '../../../Dashboard/constants/performance'

interface IBTransactionsFilterOptions {
  accountTypes?: FilterOptionsDto['accountTypes']
  dateShortcutOptions: DateShortcutOption[]
}

export const useIBTransactionsFilterOptions = (): IBTransactionsFilterOptions => {
  const { t } = useTranslation()
  const apiClient = useApiClient(ClientApiClient)
  const { account } = useAccountReadContext()

  const ibId = account?.clientIntroducingBroker?.id

  const dateShortcutOptions = useMemo<DateShortcutOption[]>(() => {
    return [
      {
        name: t('Calendar.This Month'),
        range: thisMonth,
      },
      {
        name: t('Calendar.Last Month'),
        range: lastMonth,
      },
      {
        name: t('Calendar.Current Year'),
        range: currentYear,
      },
    ]
  }, [t])

  const { data } = useQuery({
    queryKey: queryKeys.ib.rebates.filterOptions(ibId),
    queryFn: () => apiClient.getIBClientFilterOptions(ibId!),
    enabled: !!ibId,
    // staleTime: 5 * 60_000,
  })

  return {
    accountTypes: data?.accountTypes || [],
    dateShortcutOptions,
  }
}
